export default "__VITE_ASSET__CF$SpPaS__"